import { EntityDetailsModal } from '@/pages/admin/shared/entity-management/EntityDetailsModal';

type DepartmentDetailsModalProps = {
	isOpen: boolean;
	onClose: () => void;
	departmentName: string;
	initials: string;
	iconClassName: string;
	sectors: string[];
	onEditSector: (sectorIndex: number) => void;
	onDeleteSector: (sectorIndex: number) => void;
	onCreateSector?: () => void;
};

export const DepartmentDetailsModal = ({
	isOpen,
	onClose,
	departmentName,
	initials,
	iconClassName,
	sectors,
	onEditSector,
	onDeleteSector,
	onCreateSector,
}: DepartmentDetailsModalProps) => {
	return (
		<EntityDetailsModal
			isOpen={isOpen}
			onClose={onClose}
			entityName={departmentName}
			entityDescription="Detalhes e gerenciamento do departamento"
			initials={initials}
			iconClassName={iconClassName}
			listTitle="Lista de Setores"
			childItems={sectors}
			emptyTitle="Nenhum setor ainda"
			emptyDescription="Use «Novo setor» para adicionar ao departamento."
			createChildText="Novo setor"
			onEditChild={onEditSector}
			onDeleteChild={onDeleteSector}
			onCreateChild={onCreateSector}
		/>
	);
};
